module.exports = __webpack_public_path__ + "assets/images/equipe_desc.b4fa8226a9b92190b088247899c8da64.png";